import { useState } from 'react';
import { Menu, Waves, X } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';

const items = [
  ['/', 'Accueil'],
  ['/prestations', 'Prestations'],
  ['/presentation', 'Présentation'],
  ['/tarifs', 'Tarifs'],
  ['/contact', 'Contact'],
] as const;

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="site-header">
      <div className="header-inner">
        <Link className="brand" to="/" aria-label="Vague de Mots — accueil" onClick={() => setOpen(false)}>
          <img src="/assets/logo-site.jpg" alt="Vague de Mots" />
        </Link>
        <button className="menu-button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}>
          {open ? <X /> : <Menu />}
        </button>
        <nav className={open ? 'main-nav open' : 'main-nav'} aria-label="Navigation principale">
          {items.map(([to, label]) => (
            <NavLink key={to} to={to} onClick={() => setOpen(false)} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              {label}
            </NavLink>
          ))}
          <Link to="/contact" className="button button-primary nav-cta" onClick={() => setOpen(false)}>
            Prendre rendez-vous <Waves size={18} strokeWidth={1.6} />
          </Link>
        </nav>
      </div>
    </header>
  );
}
